// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".label-icon-chip{width:75px;padding:0}.label-icon-chip--large{width:unset;padding-right:10px}.label-icon-chip__label{margin-left:5px;font-size:13px;font-weight:500}.label-icon-chip .v-avatar{margin-left:1px}@media screen and (max-width:599px){.label-icon-chip{width:24px}.label-icon-chip__label{display:none}}", ""]);
// Exports
module.exports = exports;
